<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('purchaseOrder.pageTitle'),
            href: '/admin/purchase-orders',
          },
          {
            text: $t('edit'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-4">
                <div
                  class="
                    ts-border-gray-300
                    ts-border
                    ts-p-3
                    ts-h-full
                    ts-rounded
                    ts-space-y-3
                  "
                >
                  <div class="row">
                    <label
                      class="required form-col-label control-label col-md-3"
                      >{{ $t('purchaseOrder.poDate') }}</label
                    >
                    <div class="col-md-9">
                      <a-date-picker
                        v-model="model.po_date"
                        format="DD-MM-YYYY"
                        valueFormat="DD-MM-YYYY"
                        class="ts-w-full"
                      />
                      <div class="validate" v-if="errors.has('po_date')">
                        {{ errors.first('po_date') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label
                      class="required form-col-label control-label col-md-3"
                      >{{ $t('purchaseOrder.vendor') }}</label
                    >
                    <div class="col-md-9">
                      <a-select
                        v-model="model.vendor_id"
                        :options="supplierList"
                        showSearch
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        class="ts-w-full"
                      ></a-select>
                      <div class="validate" v-if="errors.has('vendor_id')">
                        {{ errors.first('vendor_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <label class="form-col-label control-label col-md-3">{{
                      $t('purchaseOrder.reference#')
                    }}</label>
                    <div class="col-md-9">
                      <input
                        v-model="model.reference_no"
                        type="text"
                        class="form-control"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="form-col-label control-label col-md-3">{{
                      $t('purchaseOrder.description')
                    }}</label>
                    <div class="col-md-9">
                      <textarea
                        v-model="model.description"
                        rows="9"
                        class="form-control ts-w-full"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <div style="height: 275px">
                    <Productlist v-model="model" class="ts-h-full" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="
                    ts-shadow-inner ts-border ts-border-gray-200 ts-rounded
                  "
                />
              </div>
            </div>
            <div class="row">
              <div
                class="
                  col-md-12
                  ts-flex ts-items-center ts-space-x-3 ts-justify-end
                "
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'purchase-order' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onUpdate"
                  color="primary"
                  >{{ $t('update') }}</ts-button
                >
              </div>
            </div>
          </form>
          <a-modal
            :title="$t('pdf')"
            width="50%"
            v-model="show_pdf"
            :footer="null"
          >
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import ItemList from './components/item-list'
import Productlist from './components/product-list'

export default {
  name: 'purchaseOrderEdit',
  components: {
    ItemList,
    Productlist,
  },
  data() {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        po_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        description: null,
        reference_no: null,
        po_detail: [],
      },
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('purchaseOrder/order', ['edit_data']),
    supplierList() {
      return this.$store.state.purchaseOrder.order.suppliers.map((el) => ({
        value: el.vendor_id,
        label: el.vendor_name,
      }))
    },
  },
  methods: {
    ...mapActions('purchaseOrder/order', [
      'getSupplier',
      'getProduct',
      'getMeasure',
      'update',
      'find',
    ]),
    async fetchData() {
      this.loading = true
      await this.getSupplier()
      await this.getProduct()
      await this.getMeasure()
      await this.find(this.$route.params.id)
      await this.setEditData()
      this.loading = false
    },
    onUpdate() {
      this.waiting = true
      this.show_pdf = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model,
      })
        .then((response) => {
          // this.$toasted.success(response.message)
          // this.$router.push({ name: 'purchase-order' })
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData() {
      this.model.po_date = this.edit_data.po_date
      this.model.vendor_id = this.edit_data.vendor_id
      this.model.description = this.edit_data.description
      this.model.reference_no = this.edit_data.reference_no
      this.model.po_detail = this.edit_data.details.map((el) => ({
        product_id: el.product_id,
        uom_id: el.uom_id,
        qty: el.quantity_order,
        uom_cat_id: el.product.uom_cat_id,
        maximum_reorder_allow: el.product.maximum_reorder_allow
          ? el.product.maximum_reorder_allow
          : 0,
        alloworder:
          el.quantity_order >
          (el.product.maximum_reorder_allow
            ? el.product.maximum_reorder_allow
            : 0),
        cost: el.cost,
        discount_rate: el.discount_rate,
        discount_type: el.discount_type,
        total_after_discount: el.total_after_discount
      }))
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('purchaseOrder/order/CLEAR_SETUP')
    this.$store.commit('purchaseOrder/order/SET_EDIT_DATA', [])
    next()
  },
}
</script>